import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromEsign from './esign-reducer';
import { EffectsModule } from '@ngrx/effects';
import { esignEffects } from './effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(fromEsign.esignFeatureKey, fromEsign.reducer),
        EffectsModule.forFeature(esignEffects)
    ]
})
export class EsignStoreModule {}
